export { default as apiErrorManager } from './apiErrorTracker';
export type { ErrorDetail } from './types';
